import { motion, useReducedMotion } from "motion/react";
import { useTranslation } from "react-i18next";

import { Container } from "../components/Container";
import { SectionHeading } from "../components/SectionHeading";

const STEP_KEYS = ["step_1", "step_2", "step_3"] as const;

export function HowItWorks() {
  const { t } = useTranslation();
  const reduce = useReducedMotion();

  return (
    <section id="how-it-works" className="py-14 sm:py-20">
      <Container>
        <SectionHeading
          eyebrow={t("how_it_works.eyebrow")}
          title={t("how_it_works.section_title")}
          description={t("how_it_works.section_description")}
        />

        <div className="relative mt-10">
          <svg
            aria-hidden="true"
            className="pointer-events-none absolute inset-x-0 top-[30px] mx-auto hidden h-2 w-[70%] lg:block"
            viewBox="0 0 1000 4"
            preserveAspectRatio="none"
          >
            <line
              x1="0"
              y1="2"
              x2="1000"
              y2="2"
              stroke="var(--color-brand-500)"
              strokeWidth="2"
              strokeDasharray="6 8"
              strokeLinecap="round"
            />
          </svg>

          <ol className="relative grid gap-12 lg:grid-cols-3 lg:gap-10">
            {STEP_KEYS.map((stepKey, i) => (
              <motion.li
                key={stepKey}
                initial={reduce ? false : { opacity: 0, y: 24 }}
                whileInView={reduce ? undefined : { opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{
                  duration: 0.5,
                  ease: "easeOut",
                  delay: i * 0.1,
                }}
                className="relative flex flex-col items-center text-center lg:px-6"
              >
                <span
                  className="relative z-10 mb-6 inline-flex h-[60px] w-[60px] items-center justify-center rounded-full bg-brand-500 text-xl font-extrabold text-white shadow-xl"
                  aria-hidden="true"
                >
                  {i + 1}
                </span>
                <h3 className="text-xl font-bold text-text-heading sm:text-2xl">
                  {t(`how_it_works.${stepKey}.title`)}
                </h3>
                <p className="mt-3 max-w-xs text-base text-text-muted">
                  {t(`how_it_works.${stepKey}.description`)}
                </p>
              </motion.li>
            ))}
          </ol>
        </div>
      </Container>
    </section>
  );
}
